export const TOPCHARTS_METRICS_INHERIT_QUERY_KEY = 'inheritTopChartsMetrics';

export type TTransInputType = 'string' | 'startDate' | 'endDate' | 'oneToManyObject' | 'array' | 'boolean';
export type TUrlQueryKey =
  | 'granularity'
  | 'start_date'
  | 'end_date'
  | 'gsd_publisher_shared'
  | 'metrics'
  | 'region'
  | 'segment'
  | 'platform'
  | 'byDevice';

export interface IFilterUrlConfigItem {
  inputPath: string;
  input: TTransInputType;
  output?: string;
  outputPath?: string;
  defaultGranularity?: any;
  outputConditionKey?: TUrlQueryKey;
}

export const FILTER_URL_CONFIG: Record<TUrlQueryKey, IFilterUrlConfigItem> = {
  granularity: {
    inputPath: 'rangeTime/type',
    input: 'string',
    output: 'granularityString',
    outputPath: 'granularity',
  },
  // 注意input的类型为moment，需要指定时间粒度，也就是outputConditionKey，同时还需要有一个默认粒度defaultGranularity
  start_date: {
    inputPath: 'rangeTime/value/0',
    input: 'startDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'start_date',
    outputConditionKey: 'granularity',
  },
  end_date: {
    inputPath: 'rangeTime/value/1',
    input: 'endDate',
    output: 'string',
    defaultGranularity: 'monthly',
    outputPath: 'end_date',
    outputConditionKey: 'granularity',
  },
  gsd_publisher_shared: {
    inputPath: 'publisher/value',
    input: 'string',
    output: 'array',
    outputPath: 'metric_condition/gsd/gsd_types',
  },
  metrics: {
    inputPath: 'metric_selection_for_trends/value/source_metrics',
    input: 'oneToManyObject',
    // 输出一对多的对象数组，例如{a: [b, c], d: [b, f]}
    output: 'oneToManyObject',
    outputPath: 'source_metrics',
  },
  region: {
    inputPath: 'region/markets',
    input: 'array',
    output: 'array',
    outputPath: 'markets',
  },
  segment: {
    inputPath: 'cascader/value',
    input: 'oneToManyObject',
    output: 'array',
    outputPath: 'metric_condition/$variable/segments',
  },
  platform: {
    inputPath: 'platform_cascader/value',
    input: 'oneToManyObject',
    output: 'array',
    outputPath: 'metric_condition/$variable/detailed_platforms',
  },
  byDevice: {
    inputPath: 'byDevice',
    input: 'boolean',
  },
};
